module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noItemsMessage":"No courses to show."},"fi":{"noItemsMessage":"Kursseja ei löytynyt."}}')
  delete Component.options._Ctor
}
